import { Marquee, Image } from '@ccg/core';
import React$1 from 'react';
import { extends as _extends, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledCategoryMarquee from './CategoryMarquee.style.js';

const CategoryMarquee = ({
  rows,
  headline
}) => {
  const renderLink = link => {
    const {
      label,
      logo
    } = link,
          rest = _objectWithoutProperties(link, ["label", "logo"]);

    return /*#__PURE__*/React$1.createElement(Link$1, _extends({
      key: link.label
    }, rest), logo ? /*#__PURE__*/React$1.createElement("div", {
      className: "categoryMarquee__logo-wrapper"
    }, /*#__PURE__*/React$1.createElement(Image, {
      src: logo[0].url,
      alt: logo.alt
    })) : /*#__PURE__*/React$1.createElement(Typography$1, {
      variant: "subline",
      as: "span",
      transform: "uppercase"
    }, label));
  };

  return /*#__PURE__*/React$1.createElement(StyledCategoryMarquee, null, headline && /*#__PURE__*/React$1.createElement("div", {
    className: "categoryMarquee__headline"
  }, /*#__PURE__*/React$1.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: headline
    }
  })), rows && rows.length > 0 && rows.map((item, index) => {
    const inverted = (index + 1) % 2 === 0;
    const seconds = 60 * (item.links.length / 3);
    return /*#__PURE__*/React$1.createElement(Marquee, {
      key: index,
      inverted: inverted,
      seconds: seconds,
      className: "categoryMarquee__marquee"
    }, item.links.map(link => renderLink(link)));
  }));
};

CategoryMarquee.propTypes = {
  headline: PropTypes$1.string,
  rows: PropTypes$1.arrayOf(PropTypes$1.shape({
    links: PropTypes$1.arrayOf(PropTypes$1.shape({
      label: PropTypes$1.string
    }))
  })).isRequired
};
CategoryMarquee.defaultProps = {
  headline: null
};

export default CategoryMarquee;
